"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerProgressWatchListenner = exports.createWatchSession = exports.rateWatchContent = exports.setWatchParams = exports.PlayerTypesEnum = void 0;
var ContentWatchTrackerApi_1 = require("./api/ContentWatchTrackerApi");
var isCuePoint_1 = require("./utils/isCuePoint");
var progress_1 = require("./services/progress");
var getWatchedPercentage_1 = require("./utils/getWatchedPercentage");
var shouldSaveCuePoint_1 = require("./utils/shouldSaveCuePoint");
var getWatchedRangesTime_1 = require("./utils/getWatchedRangesTime");
var constants_1 = require("./constants");
var PlayerTypesEnum_1 = require("./enums/PlayerTypesEnum");
Object.defineProperty(exports, "PlayerTypesEnum", { enumerable: true, get: function () { return PlayerTypesEnum_1.PlayerTypesEnum; } });
__exportStar(require("./typings"), exports);
var watchSession = null;
var cuePointsRegistered = new Set();
var setWatchParams = function (params) {
    ContentWatchTrackerApi_1.ContentWatchTrackerApi.getApi(params);
};
exports.setWatchParams = setWatchParams;
var rateWatchContent = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var api;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                api = ContentWatchTrackerApi_1.ContentWatchTrackerApi.getApi();
                if (!(watchSession === null || watchSession === void 0 ? void 0 : watchSession.id))
                    throw new Error('No watch session id');
                return [4 /*yield*/, api.post('/content/rating', {
                        watchId: +watchSession.id,
                        rate: params.rate,
                        comment: params.comment,
                    })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.rateWatchContent = rateWatchContent;
var createWatchSession = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var api, data, error_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                api = ContentWatchTrackerApi_1.ContentWatchTrackerApi.getApi();
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, api.post('/content/watch', payload)];
            case 2:
                data = (_b.sent()).data;
                watchSession = data;
                return [3 /*break*/, 4];
            case 3:
                error_1 = _b.sent();
                console.log('watch session error: ', error_1);
                watchSession = null;
                return [3 /*break*/, 4];
            case 4:
                cuePointsRegistered.clear();
                return [2 /*return*/, (_a = watchSession === null || watchSession === void 0 ? void 0 : watchSession.id) !== null && _a !== void 0 ? _a : 0];
        }
    });
}); };
exports.createWatchSession = createWatchSession;
var registerProgressWatchListenner = function (payload, socketInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, mediaDuration, getCurrentTime, watchedRanges, watchedRangesTime, registeredSuccess, currentTime, currentPercentage, watchedPercentage, watchedTime, registerPayload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = payload.playerTimes, mediaDuration = _a.mediaDuration, getCurrentTime = _a.getCurrentTime, watchedRanges = payload.watchedRanges, watchedRangesTime = payload.watchedRangesTime;
                registeredSuccess = false;
                currentTime = getCurrentTime();
                currentPercentage = (0, getWatchedPercentage_1.getWatchedPercentage)(currentTime, mediaDuration);
                if (!(watchSession === null || watchSession === void 0 ? void 0 : watchSession.id))
                    return [2 /*return*/, { success: false }];
                if (!((0, isCuePoint_1.isCuePoint)(mediaDuration, currentTime) && (0, shouldSaveCuePoint_1.shouldSaveCuePoint)(cuePointsRegistered, currentPercentage))) return [3 /*break*/, 2];
                cuePointsRegistered.add(currentPercentage);
                watchedPercentage = constants_1.DEFAULT_CUE_POINT_PERCENTAGE_INTERVAL * cuePointsRegistered.size;
                watchedTime = watchedPercentage * (mediaDuration / 100);
                registerPayload = {
                    id: +(watchSession === null || watchSession === void 0 ? void 0 : watchSession.id),
                    percent: watchedPercentage,
                    watchTime: watchedTime,
                };
                if (watchedRanges) {
                    registerPayload.watchedRanges = watchedRanges;
                    registerPayload.watchedRangesTime = watchedRangesTime !== null && watchedRangesTime !== void 0 ? watchedRangesTime : (0, getWatchedRangesTime_1.getWatchedRangesTime)(registerPayload.watchedRanges);
                }
                return [4 /*yield*/, (0, progress_1.registerProgress)(registerPayload, socketInstance)];
            case 1:
                registeredSuccess = _b.sent();
                _b.label = 2;
            case 2: return [2 /*return*/, { success: registeredSuccess }];
        }
    });
}); };
exports.registerProgressWatchListenner = registerProgressWatchListenner;
